<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.53 15.93c-.16-.27-.61-.69-1.73-.49a8.46 8.46 0 0 1-1.88.13 8.409 8.409 0 0 1-5.91-2.82 8.068 8.068 0 0 1-1.68-8.51c.34-.78.18-1.3-.04-1.61-.22-.31-.69-.7-1.55-.44a9.983 9.983 0 0 0-6.27 6.39c-1.14 4.25.71 8.73 4.61 10.85a9.66 9.66 0 0 0 4.63 1.17c.69 0 1.39-.09 2.07-.27 3.23-.78 5.74-3.14 6.88-6.07.23-.59.14-1.08-.13-1.33Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconMoon'
}
</script>
